module.exports = __webpack_public_path__ + "static/media/fight.ce6c810d.svg";